"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductEnum = void 0;
var _Icon = _interopRequireWildcard(require("../entities/Icon"));
var _react = _interopRequireDefault(require("react"));
var _ProductTypeEnum = _interopRequireDefault(require("./ProductTypeEnum"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var productIds = {
  pharmacyProductId: 1,
  quantifyProductId: 2,
  infectionPreventionProductId: 3,
  veriFormProductId: 4,
  ruleProductId: 5,
  analyticsProductId: 6,
  simplifiProductId: 7,
  pocAdvisorProductId: 8,
  medStorageProductId: 9,
  sepsisMonitorProductId: 10,
  medTraysProductId: 11,
  patientDecompensationId: 12,
  documentationProductId: 13,
  aurReportingProductId: 14,
  flowlyticsProductId: 15,
  ivWorkflowProductId: 16,
  userManagementProductId: 99,
  superUserProductId: 101
};

// structure of enum:
//         id -  product id in Identifi, should be the same in all applications
//         name -  name of product,
//         abbreviation -
//         type - type of product (for grouping),
//         icon - object of type Icon like new Icon("icon-pill"),
//         iconContainerClass - class of patent element,
//         label - visible product name in left menu (if there is no override in "leftMenuLabel") and in Product Selector in Identifi,
//         iconClass - string of icon class name in Identifi (Product Selector),
//         iconName - string of icon name in Identifi (Product Selector),
//         tileClassName - class name for tile in Identifi Product Selector,
//         leftMenuLabel - visible product name in left menu
//         ariaLabel - aria-label attribute
var ProductEnum = exports.ProductEnum = {
  Pharmacy: {
    id: productIds.pharmacyProductId,
    name: "Sentri7 Pharmacy",
    abbreviation: "s7",
    type: _ProductTypeEnum["default"].surveillance,
    icon: new _Icon["default"]("icon-pill"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Pharmacy"),
    iconClass: "custom-icon icon-pill",
    tileClassName: "pharmacy"
  },
  Quantifi: {
    id: productIds.quantifyProductId,
    name: "Quantifi",
    abbreviation: "q",
    type: _ProductTypeEnum["default"].surveillance,
    icon: new _Icon["default"]("ion-md-stats"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-stats-bars",
    tileClassName: "quantifi",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Quantifi", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"))
  },
  InfectionPrevention: {
    id: productIds.infectionPreventionProductId,
    name: "Sentri7 Infection Prevention",
    abbreviation: "s7",
    type: _ProductTypeEnum["default"].surveillance,
    icon: new _Icon["default"]("ion-md-bug"),
    iconContainerClass: "icon-product",
    iconClass: "icon bug_report",
    tileClassName: "ip",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Infection Prevention")
  },
  Veriform: {
    id: productIds.veriFormProductId,
    name: "Veriform",
    abbreviation: "v",
    type: _ProductTypeEnum["default"].safety,
    icon: new _Icon["default"]("ion-md-clipboard"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon list-alt--outline",
    tileClassName: "veriform",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "VeriForm", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"))
  },
  Simplifi: {
    id: productIds.simplifiProductId,
    name: "Simplifi 797",
    abbreviation: "s",
    type: _ProductTypeEnum["default"].safety,
    icon: new _Icon["default"]("icon-syringe"),
    iconContainerClass: "icon-product",
    iconClass: "icon-syringe",
    tileClassName: "simplifi",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Simplifi 797", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"))
  },
  Analytics: {
    id: productIds.analyticsProductId,
    name: "Analytics",
    abbreviation: "a",
    type: _ProductTypeEnum["default"].tools,
    icon: new _Icon["default"]("ion-md-pulse"),
    iconContainerClass: "permission-analytics",
    iconClass: "icon ion-ios-pulse-strong",
    tileClassName: "analytics",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Analytics")
  },
  UserManagement: {
    id: productIds.userManagementProductId,
    name: "Settings & User Management",
    abbreviation: "cm",
    type: _ProductTypeEnum["default"].tools,
    icon: new _Icon["default"]("icon-cogs"),
    iconContainerClass: "permission-userManagement",
    iconClass: "icon settings",
    tileClassName: "admin",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Settings & User Management")
  },
  RuleManagement: {
    id: productIds.ruleProductId,
    name: "Rules Management",
    abbreviation: "rm",
    type: _ProductTypeEnum["default"].tools,
    icon: new _Icon["default"]("widgets"),
    iconContainerClass: "permission-ruleManagement",
    iconClass: "icon widgets",
    tileClassName: "rules",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Rules Management")
  },
  PocAdvisor: {
    id: productIds.pocAdvisorProductId,
    name: "POC Advisor",
    abbreviation: "pa",
    type: _ProductTypeEnum["default"].surveillance,
    icon: new _Icon["default"]("flag"),
    iconContainerClass: "icon-product",
    iconClass: "icon flag",
    tileClassName: "pocadvisor",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "POC Advisor", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"))
  },
  SuperUser: {
    id: productIds.superUserProductId,
    name: "Super User",
    abbreviation: "",
    type: _ProductTypeEnum["default"].tools,
    icon: new _Icon["default"]("ion-ios-color-wand"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-ios-color-wand",
    tileClassName: "superuser",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Super User")
  },
  MedStorage: {
    id: productIds.medStorageProductId,
    name: "Simplifi+ MedStorage",
    abbreviation: "m",
    type: _ProductTypeEnum["default"].safety,
    icon: new _Icon["default"]("checklist"),
    iconContainerClass: "icon-product",
    iconClass: "checklist",
    tileClassName: "med-storage",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Simplifi+", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"), " MedStorage"),
    leftMenuLabel: /*#__PURE__*/_react["default"].createElement("span", null, "MedStorage"),
    ariaLabel: "Simplify Plus MedStorage"
  },
  MedTrays: {
    id: productIds.medTraysProductId,
    name: "Simplifi+ MedTrays",
    abbreviation: "mt",
    type: _ProductTypeEnum["default"].safety,
    icon: new _Icon["default"]("view_quilt"),
    iconContainerClass: "icon-product med-trays",
    iconClass: "icon view_quilt",
    tileClassName: "med-trays",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Simplifi+", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"), " MedTrays"),
    leftMenuLabel: /*#__PURE__*/_react["default"].createElement("span", null, "MedTrays"),
    ariaLabel: "Simplify Plus MedTrays"
  },
  SepsisMonitor: {
    id: productIds.sepsisMonitorProductId,
    name: "Sepsis Monitor",
    abbreviation: "fl",
    type: _ProductTypeEnum["default"].surveillance,
    icon: new _Icon["default"]("custom-icon icon-policy"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon icon-policy",
    tileClassName: "sepsis-monitor",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Sepsis Monitor")
  },
  PatientDecompensation: {
    id: productIds.patientDecompensationId,
    name: "Pharmacy (New)",
    abbreviation: "pd",
    type: _ProductTypeEnum["default"].surveillance,
    // Icon name should be in pascal case for svg icons both here and in assets/svg as they will be converted to react components
    icon: new _Icon["default"]("SvgPharmacyNew", _Icon.IconTypes.svg, "pharmacy-new"),
    iconContainerClass: "icon-product",
    iconClass: "pharmacy-new",
    tileClassName: "pharmacy-new-tile",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Pharmacy (New)"),
    ariaLabel: "Pharmacy New"
  },
  AurReporting: {
    id: productIds.aurReportingProductId,
    name: "AUR Reporting",
    abbreviation: "aur",
    type: _ProductTypeEnum["default"].surveillance,
    iconClass: "material-symbols-outlined",
    icon: new _Icon["default"]("icon-data-exploration"),
    iconContainerClass: "icon-product",
    tileClassName: "S7AurOnly",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "AUR Reporting")
  },
  Flowlytics: {
    id: productIds.flowlyticsProductId,
    name: "Drug Diversion",
    abbreviation: "fl",
    type: _ProductTypeEnum["default"].surveillance,
    icon: new _Icon["default"]("icon-alt-route"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Drug Diversion"),
    iconClass: "material-symbols-outlined",
    tileClassName: "flowlytics"
  },
  IVWorkflow: {
    id: productIds.ivWorkflowProductId,
    name: "Simplifi+ IV Workflow",
    abbreviation: "ivw",
    type: _ProductTypeEnum["default"].safety,
    icon: new _Icon["default"]("iv-workflow"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Simplifi+", /*#__PURE__*/_react["default"].createElement("sup", null, "\xAE"), " IV Workflow"),
    iconClass: "iv-workflow",
    tileClassName: "ivWorkflow",
    ariaLabel: "Simplify Plus IV Workflow"
  }
};
var _default = exports["default"] = ProductEnum;